<template>
  <div class="not-found">
    <div class="hero-body">
      <div class="container has-text-centered" style="min-height:300px">
        <h2 class="title is-5">
        
              {{mes}} <br>
              Tự động chuyển trang trong 5s.
        </h2>
        <!--<router-link :to="{name: 'HomePage'}" class="button is-info">Quay về trang chủ</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>

import UsersService from "@/services/UsersService";

export default {
  name: "Confirmation",
  data() {
    return {
      mes: ''
    }
  },
  created() {
    
  },
  async mounted(){
    const self = this;
    let url_string = window.location.href.split('#'); //window.location.href
    let url = new URL(url_string);
    let token = url.searchParams.get("token");
    if(token) {
     UsersService.confirmation({token: token})
      .then(res => {
        self.mes = res.data.message
        setTimeout(function () {
          window.location.href = 'http://vvcroom-portal.viettel.vn/#/login';
        }, 5000);
      }).catch(err => {
        console.log("err", err)
      })
    } else {
      setTimeout(function () {
        window.location.href = 'http://vvcroom-portal.viettel.vn/#/login';
      }, 5000);
    }

     
  }
};
</script>